import { ReactNode } from 'react';
import { TdsIcon } from '@scania/tegel-react';

export type MenuItemTitle = 'Search customer' | 'Evaluate chassis numbers' | 'Manual mode' | 'Sandbox mode';

export interface MenuItem {
  title: MenuItemTitle;
  description: string;
  icon: ReactNode;
  dataTestid?: string;
  disabled?: boolean;
}

const menuItems: MenuItem[] = [
  {
    title: 'Search customer',
    description: 'Load customers chassis numbers',
    icon: <TdsIcon name="profile" size="20px" />,
    dataTestid: 'search-customer-menu-item',
  },
  {
    title: 'Evaluate chassis numbers',
    description: 'Input chassis numbers',
    icon: <TdsIcon name="truck" size="20px" />,
    dataTestid: 'scania-chassis-menu-item',
  },
  {
    title: 'Manual mode',
    description: 'Create vehicles from scratch',
    icon: <TdsIcon name="document_tool" size="20px" />,
    dataTestid: 'manual-mode-menu-item',
    disabled: true,
  },
];

export default menuItems;
